export const setUTCDate = (dateString) => {
  const result = [];
  dateString?.forEach((item) => {
    const [datePart, timePart] = item?.split(" ");
    const [hour, minute, second] = timePart.split(":").map(Number);
    const date = new Date(item);
    date.setUTCHours(hour, minute, second, 0);
    result.push(date.toISOString());
  });
  return result;
};


export function getLastDayRange() {
  // Get the current date
  const now = new Date();

  // Create the "to" date: today at 7:15 AM (local time)
  const toDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 7, 15);

  // Create the "from" date: yesterday at 7:15 AM (local time)
  const fromDate = new Date(toDate);
  fromDate.setDate(toDate.getDate() - 1);

  // Format the dates in local time
  return {
    from: fromDate.toLocaleString(),
    to: toDate.toLocaleString(),
  };
}


export function getLastDayTimeRange() {
  // Create a Date object for the current time
  const now = new Date();

  // Set Indian Standard Time (IST) offset
  const ISTOffset = 5.5 * 60 * 60 * 1000; // 5 hours 30 minutes in milliseconds

  // Convert current time to IST
  const currentTimeIST = new Date(now.getTime() + ISTOffset);

  // Create a "to" date for today at 7:15 AM
  const toDate = new Date(currentTimeIST); 
  toDate.setHours(7, 15, 0, 0); // Set to 7:15 AM

  // If the current time is before today's 7:15 AM, set "toDate" to yesterday at 7:15 AM
  if (currentTimeIST.getHours() < 7 || (currentTimeIST.getHours() === 7 && currentTimeIST.getMinutes() < 15)) {
    toDate.setDate(toDate.getDate() - 1);
  }

  // Create a "from" date for the previous day at 7:15 AM
  const fromDate = new Date(toDate);
  fromDate.setDate(fromDate.getDate() - 1); // Move to the previous day

  // Convert back to IST-neutral time for return
  const fromDateUTC = new Date(fromDate.getTime() - ISTOffset);
  const toDateUTC = new Date(toDate.getTime() - ISTOffset);

  return {
    from: fromDateUTC.toISOString(),
    to: toDateUTC.toISOString(),
  };
}

// Example usage
console.log(getLastDayRange());

export function getYesterdayToTodayTimeRangeIST() {
  // Create the current IST time
  const now = new Date();

  // Define IST offset (+5:30)
  const ISTOffset = 5.5 * 60 * 60 * 1000;

  // Convert the current UTC time to IST
  const nowIST = new Date(now.getTime() + ISTOffset);

  // Create "to" date for today at 7:15 AM IST
  const toDateIST = new Date(nowIST);
  toDateIST.setHours(7, 15, 0, 0); // Set time to 7:15 AM IST

  // If the current time in IST is before today's 7:15 AM, adjust "toDateIST" to yesterday
  if (nowIST.getHours() < 7 || (nowIST.getHours() === 7 && nowIST.getMinutes() < 15)) {
    toDateIST.setDate(toDateIST.getDate() - 1);
  }

  // Create "from" date for yesterday at 7:15 AM IST
  const fromDateIST = new Date(toDateIST);
  fromDateIST.setDate(toDateIST.getDate() - 1); // Set it to one day earlier

  // Convert back to UTC
  const fromDateUTC = new Date(fromDateIST.getTime() - ISTOffset);
  const toDateUTC = new Date(toDateIST.getTime() - ISTOffset);

  // Format the IST timestamps for output
  const formatISTDate = (date) => {
    return `${date.getFullYear()}-${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")} ${date
      .getHours()
      .toString()
      .padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}`;
  };

  return {
    from: formatISTDate(fromDateIST), // From date in IST
    to: formatISTDate(toDateIST), // To date in IST
  };
}

console.log(getYesterdayToTodayTimeRangeIST())

export function getLastDayTimeRangeUTC() {
  // Helper function to calculate the exact UTC time
  function getUTCTimestamp(date, hour, minute) {
    date.setUTCHours(hour, minute, 0, 0); // Set UTC hours and minutes
    return date.toISOString();
  }

  const now = new Date(); // Current UTC time

  // Create the "to" timestamp for today at 7:15 AM UTC
  const toDate = new Date(now);
  if (now.getUTCHours() < 7 || (now.getUTCHours() === 7 && now.getUTCMinutes() < 15)) {
    // If the current UTC time is before today's 7:15 AM, set "toDate" to yesterday's 7:15 AM
    toDate.setUTCDate(toDate.getUTCDate() - 1); 
  }
  const toTimestamp = getUTCTimestamp(toDate, 7, 15);

  // Create the "from" timestamp for yesterday at 7:15 AM UTC
  const fromDate = new Date(toDate);
  fromDate.setUTCDate(fromDate.getUTCDate() - 1);
  const fromTimestamp = getUTCTimestamp(fromDate, 7, 15);

  return {
    from: fromTimestamp,
    to: toTimestamp,
  };
}

export function getLastDayTimeRangeIST() {
  // Helper function to calculate the exact IST time in ISO format
  function getISTTimestamp(date, hour, minute) {
    date.setHours(hour, minute, 0, 0); // Set local (IST) hours and minutes
    return new Date(date.getTime() + 5.5 * 60 * 60 * 1000).toISOString(); // Convert to UTC and format as ISO
  }

  const now = new Date(); // Current local time (assumed to be IST)

  // Create the "to" timestamp for today at 7:15 AM IST
  const toDate = new Date(now);
  toDate.setHours(7, 15, 0, 0);

  // If the current IST time is before today's 7:15 AM, set "toDate" to yesterday's 7:15 AM
  if (now < toDate) {
    toDate.setDate(toDate.getDate() - 1);
  }

  const toTimestamp = getISTTimestamp(toDate, 7, 15);

  // Create the "from" timestamp for yesterday at 7:15 AM IST
  const fromDate = new Date(toDate);
  fromDate.setDate(fromDate.getDate() - 1);
  const fromTimestamp = getISTTimestamp(fromDate, 7, 15);

  return {
    from: fromTimestamp,
    to: toTimestamp,
  };
}


// Example usage
console.log(getLastDayTimeRangeIST());
console.log(getLastDayTimeRangeUTC());


const range = getLastDayRange();
console.log('From:', range.from);
console.log('To:', range.to);


export function generatedISOFormatDateString (date) {
  // console.log(date)
  const currentDate =  date.toLocaleString("en-US", { hour12: false });
  const [month, day, rem] = currentDate.split("/");
  const [year, time] = rem?.split(", ");
  const [hour, minute, seconds] = time.split(":");

  const formattedDate = `${year}-${month}-${day}T${hour}:${minute}:${seconds}.000Z`

  return formattedDate
}

function parseCustomDateString(dateString) {
  console.log(dateString);
  const [day, month, year, time, meridian] = dateString.split(/[\s,:/]+/);
  let [hours, minutes, seconds] = time.split(':').map(Number);

  // Convert 12-hour format to 24-hour format
  if (meridian.toLowerCase() === 'pm' && hours !== 12) {
    hours += 12;
  } else if (meridian.toLowerCase() === 'am' && hours === 12) { 
    hours = 0;
  }

  return new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds));
}

export function calculateDateRangeFromDate(date, minutesBefore, minutesAfter) { 
  // console.log(dateString)
  // const date = parseCustomDateString(dateString) 
  // console.log(date)

  const fromDate = new Date(date);
  const toDate = new Date(date); 
  console.log(fromDate)

  // console.log(fromDate)
  // console.log(toDate)

  const fromMin = fromDate.getMinutes() - minutesBefore;
  const toMin = toDate.getMinutes() + minutesAfter;

  fromDate.setMinutes(fromMin);
  toDate.setMinutes(toMin);

  // Set current hours
  // const currentHours = date.getHours();
  // fromDate.setUTCHours(currentHours);
  // toDate.setUTCHours(currentHours);
  console.log(fromDate)

  const formattedFromDate = generatedISOFormatDateString(fromDate)
  const formattedToDate = generatedISOFormatDateString(toDate)

  return {
    from: formattedFromDate,
    to: formattedToDate,
  };
}

export function filterDataByTimeRange(data, timeRangeMinutes) {j
  const timeRangeMilliseconds = timeRangeMinutes * 60 * 1000;
  const currentTime = new Date();

  currentTime.setUTCHours(currentTime.getHours());
  currentTime.setUTCMinutes(currentTime.getMinutes());
  currentTime.setUTCSeconds(currentTime.getSeconds());
  currentTime.setUTCMilliseconds(currentTime.getMilliseconds());

  return data.filter((item) => {
    const itemTime = new Date(item.CreatedON);
    // if range is 15 filter the last 15 mins data
    return currentTime - itemTime <= timeRangeMilliseconds;
  });
}

export function groupDataByInterval(data, inter, period, date) {
  const groupedData = {};
  const firstSelected = data[0]

  const firstRecordCreatedONArray = [];
  const chartArray = [];

  let intervalInMilliseconds;

  switch (period) {
    case "month":
      intervalInMilliseconds = inter * 30.44 * 24 * 60 * 60 * 1000; // Months
      break;
    case "week":
      intervalInMilliseconds = inter * 7 * 24 * 60 * 60 * 1000; // Weeks
      break;
    case "day":
      intervalInMilliseconds = inter * 24 * 60 * 60 * 1000; // Days
      break;
    case "min":
      intervalInMilliseconds = inter * 60 * 1000; // Minutes
      break;
    default:
      throw new Error("Invalid period");
  }

  // let intervalStartTime = new Date(data[0].createdON).getTime()
  let intervalStartTime = new Date(date).getTime()
  let startTime = new Date(intervalStartTime)


  // group the item based on meter name and interval
  data?.forEach((item) => {
    const timestamp = new Date(item.createdON)
    // const intervalKey = new Date(
    //   Math.floor(timestamp / intervalInMilliseconds) * intervalInMilliseconds
    // ).toLocaleString()
    if(timestamp > startTime){
      startTime = new Date(new Date(startTime).getTime()+intervalInMilliseconds)
    }

    const intervalKey = new Date(startTime).toLocaleString()
    const intervalDate = new Date(startTime - intervalInMilliseconds).toLocaleString()

    if (!groupedData[item.metername]) {
      groupedData[item.metername] = {};
    }

    if (!groupedData[item.metername][intervalKey]) {
      groupedData[item.metername][intervalKey] = {
        records: [],
      };
    }

    groupedData[item.metername][intervalKey]?.records.push({
      Cumulative: item.cumulative,
    });
    if (item.meterid === firstSelected.meterid && groupedData[item.metername][intervalKey].records.length === 1) {
      console.log(groupedData[item.metername][intervalKey])
      if(!firstRecordCreatedONArray.includes(intervalDate)){
        firstRecordCreatedONArray.push(intervalDate);
      }
    }
  });
  // calculate the column value and push into specific array
  for (const metername in groupedData) {
    const meterValues = [];

    for (const intervalKey in groupedData[metername]) {
      const records = groupedData[metername][intervalKey].records;
      const firstRecord = records[0];
      const lastRecord = records[records.length - 1];

      if (!groupedData[metername][intervalKey].finalValues) {
        groupedData[metername][intervalKey].finalValues = {};
      }
      groupedData[metername][intervalKey].finalValues.Cumulative =
        Math.abs(firstRecord?.Cumulative - lastRecord?.Cumulative);

      // Push cumulative value into meterValues
      meterValues.push(groupedData[metername][intervalKey].finalValues.Cumulative);
    }
    // Push an object into chartArray for each meterName
    chartArray.push({
      name: metername,
      data: meterValues,
    });
  }
  console.log(chartArray)

  console.log(groupedData)
  console.log(firstRecordCreatedONArray)
  return { chartArray, firstRecordCreatedONArray };
}


export function roundToTwoDecimalPlaces(number) {
  // Round the number to 2 decimal places using mathematical operations
  let roundedNumber = Math.round(number * 100) / 100;

  // Convert the rounded number to a string
  let roundedString = roundedNumber.toString();

  // Ensure that there are always 2 decimal places by appending zeros if needed
  // if (!roundedString.includes(".")) {
  //   roundedString += ".00";
  // } else if (roundedString.split(".")[1].length === 1) {
  //   roundedString += "0";
  // }
  
  return roundedString;
}

export const roundOffValue = (value) => {
  return Math.round(value);
};


export function groupDataByIntervalRhAndTemp(data, inter, period, date) {
  const groupedData = {};
  const firstSelected = data[0]

  const firstRecordCreatedONArray = [];
  const chartArray = [];

  let intervalInMilliseconds;

  switch (period) {
    case "month":
      intervalInMilliseconds = inter * 30.44 * 24 * 60 * 60 * 1000; // Months
      break;
    case "week":
      intervalInMilliseconds = inter * 7 * 24 * 60 * 60 * 1000; // Weeks
      break;
    case "day":
      intervalInMilliseconds = inter * 24 * 60 * 60 * 1000; // Days
      break;
    case "min":
      intervalInMilliseconds = inter * 60 * 1000; // Minutes
      break;
    default:
      throw new Error("Invalid period");
  }

  // let intervalStartTime = new Date(data[0].createdON).getTime()
  let intervalStartTime = new Date(date).getTime()
  let startTime = new Date(intervalStartTime)

  console.log(data)


  // group the item based on meter name and interval
  data?.forEach((item) => {
    const timestamp = new Date(item.createdON)
    // const intervalKey = new Date(
    //   Math.floor(timestamp / intervalInMilliseconds) * intervalInMilliseconds
    // ).toLocaleString()
    if(timestamp > startTime){
      startTime = new Date(new Date(startTime).getTime()+intervalInMilliseconds)
    }

    const intervalKey = new Date(startTime).toLocaleString()
    const intervalDate = new Date(startTime - intervalInMilliseconds).toLocaleString()

    if (!groupedData[item.metername]) {
      groupedData[item.metername] = {};
    }
    console.log(groupedData)

    if (!groupedData[item.metername][intervalKey]) {
      groupedData[item.metername][intervalKey] = {
        records: [],
      };
    }

    groupedData[item.metername][intervalKey]?.records.push({
      rh: item.rh,
    });
    console.log(groupedData)
    if (item.meterid === firstSelected.meterid && groupedData[item.metername][intervalKey].records.length === 1) {
      console.log(groupedData[item.metername][intervalKey])
      if(!firstRecordCreatedONArray.includes(intervalDate)){
        firstRecordCreatedONArray.push(intervalDate);
      }
    }
  });
  // calculate the column value and push into specific array
  for (const metername in groupedData) {
    const meterValues = [];

    for (const intervalKey in groupedData[metername]) {
      const records = groupedData[metername][intervalKey].records;
      const firstRecord = records[0];
      const lastRecord = records[records.length - 1];

      if (!groupedData[metername][intervalKey].finalValues) {
        groupedData[metername][intervalKey].finalValues = {};
      }
      groupedData[metername][intervalKey].finalValues.rh =
        Math.abs(firstRecord?.rh - lastRecord?.rh);

      // Push rh value into meterValues
      meterValues.push(groupedData[metername][intervalKey].finalValues.rh);
    }
    // Push an object into chartArray for each meterName
    chartArray.push({
      name: metername,
      data: meterValues,
    });
  } 
  console.log(chartArray)

  console.log(groupedData)
  console.log(firstRecordCreatedONArray) 
  return { chartArray, firstRecordCreatedONArray };
}






// export function groupDataByIntervalElectrical(data, inter, period, startDate) {
//   const groupedData = {};
//   const firstSelected = data[0];
//   const firstRecordCreatedONArray = [];
//   const chartArray = [];
//   console.log(startDate);
//   console.log(data);

//   let intervalInMilliseconds;

//   // Calculate interval in milliseconds based on period
//   switch (period) {
//     case "month":
//       intervalInMilliseconds = inter * 30.44 * 24 * 60 * 60 * 1000; // Approximate month
//       break;
//     case "week":
//       intervalInMilliseconds = inter * 7 * 24 * 60 * 60 * 1000; // Week
//       break;
//     case "day":
//       intervalInMilliseconds = inter * 24 * 60 * 60 * 1000; // Day
//       break;
//     case "min":
//       intervalInMilliseconds = inter * 60 * 1000; // Minute
//       break;
//     default:
//       throw new Error("Invalid period");
//   }

//   // Start interval from the specified start date
//   let intervalStartTime = new Date(startDate).getTime();

//   // Initialize grouped data for each meter
//   const meterNames = [...new Set(data.map((item) => item.METERNAME))];
//   meterNames.forEach((meterName) => {
//     groupedData[meterName] = {};
//   });

//   // Group data by intervals and meters
//   data.forEach((item) => {
//     const timestamp = new Date(item.CreatedOn).getTime();
//     while (timestamp >= intervalStartTime + intervalInMilliseconds) {
//       intervalStartTime += intervalInMilliseconds;
//     }
//     const intervalKey = new Date(intervalStartTime).toLocaleString();

//     if (!groupedData[item.METERNAME][intervalKey]) {
//       groupedData[item.METERNAME][intervalKey] = { records: [] };
//     }

//     groupedData[item.METERNAME][intervalKey].records.push({
//       Cumulative: item.KWHTotal,
//     });

//     if (
//       item.MeterId === firstSelected.MeterId &&
//       !firstRecordCreatedONArray.includes(intervalKey)
//     ) {
//       firstRecordCreatedONArray.push(intervalKey);
//     }
//   });

//   // Calculate cumulative values for each interval and fill missing intervals with 0
//   for (const meterName in groupedData) {
//     const meterValues = [];
//     let currentInterval = new Date(startDate).getTime();
//     const meterIntervals = Object.keys(groupedData[meterName]).sort(
//       (a, b) => new Date(a).getTime() - new Date(b).getTime()
//     );

//     // Iterate over all possible intervals
//     while (currentInterval <= new Date().getTime()) {
//       const intervalKey = new Date(currentInterval).toLocaleString();

//       if (groupedData[meterName][intervalKey]) {
//         const records = groupedData[meterName][intervalKey].records;
//         const firstRecord = records[0];
//         const lastRecord = records[records.length - 1];

//         groupedData[meterName][intervalKey].finalValues = {
//           Cumulative: Math.abs(firstRecord?.Cumulative - lastRecord?.Cumulative),
//         };
//         meterValues.push(groupedData[meterName][intervalKey].finalValues.Cumulative);
//       } else {
//         groupedData[meterName][intervalKey] = {
//           finalValues: { Cumulative: 0 },
//         };
//         meterValues.push(0);
//       }

//       currentInterval += intervalInMilliseconds;
//     }

//     // Append data to chartArray for each meter
//     chartArray.push({
//       name: meterName,
//       data: meterValues,
//     });
//   }

//   console.log(chartArray);
//   console.log(groupedData);
//   console.log(firstRecordCreatedONArray);

//   return { chartArray,groupedData, firstRecordCreatedONArray };
// }


// export function groupDataByIntervalElectrical(data, inter, period, startDate) {
//   const groupedData = {};
//   const firstSelected = data[0];
//   const firstRecordCreatedONArray = [];
//   const chartArray = [];
//   console.log(startDate)
//   console.log(data)

//   let intervalInMilliseconds;

//   // Calculate interval in milliseconds based on period
//   switch (period) {
//     case "month":
//       intervalInMilliseconds = inter * 30.44 * 24 * 60 * 60 * 1000; // Approximate month
//       break;
//     case "week":
//       intervalInMilliseconds = inter * 7 * 24 * 60 * 60 * 1000; // Week
//       break;
//     case "day":
//       intervalInMilliseconds = inter * 24 * 60 * 60 * 1000; // Day
//       break;
//     case "min":
//       intervalInMilliseconds = inter * 60 * 1000; // Minute
//       break;
//     default:
//       throw new Error("Invalid period");
//   }

//   // Start interval from the specified start date
//   let intervalStartTime = new Date(startDate).getTime();
//   let startTime = new Date(intervalStartTime);

//   // Group data based on meter name and intervals
//   data.forEach((item) => {
//     const timestamp = new Date(item.CreatedOn);

//     // Increment start time by interval if timestamp exceeds current interval
//     if (timestamp > startTime) {
//       startTime = new Date(startTime.getTime() + intervalInMilliseconds);
//     }

//     const intervalKey = startTime.toLocaleString();
//     const intervalDate = new Date(startTime - intervalInMilliseconds).toLocaleString();

//     if (!groupedData[item.METERNAME]) {
//       groupedData[item.METERNAME] = {};
//     }

//     if (!groupedData[item.METERNAME][intervalKey]) {
//       groupedData[item.METERNAME][intervalKey] = { records: [] };
//     }

//     // Push item data to grouped records
//     groupedData[item.METERNAME][intervalKey].records.push({
//       Cumulative: item.KWHTotal, 
//     });

//     // Store the first record dates for the selected meter 
//     if (item.MeterId === firstSelected.MeterId && !firstRecordCreatedONArray.includes(intervalDate)) {
//       firstRecordCreatedONArray.push(intervalDate);
//     }
//   });  

//   // Calculate cumulative values for each interval and meter
//   for (const meterName in groupedData) {
//     const meterValues = [];

//     for (const intervalKey in groupedData[meterName]) {
//       const records = groupedData[meterName][intervalKey].records;
//       const firstRecord = records[0];
//       const lastRecord = records[records.length - 1];

//       if (!groupedData[meterName][intervalKey].finalValues) {
//         groupedData[meterName][intervalKey].finalValues = {};
//       }
//       groupedData[meterName][intervalKey].finalValues.Cumulative =
//         Math.abs(firstRecord?.Cumulative - lastRecord?.Cumulative);

//       // Push cumulative values to meterValues
//       meterValues.push(groupedData[meterName][intervalKey].finalValues.Cumulative);
//     }
//     meterValues.shift()

//     // Append data to chartArray for each meter
//     chartArray.push({ 
//       name: meterName, 
//       data: meterValues,
//     });
//   }
//   console.log(chartArray)

//   console.log(chartArray);
//   console.log(groupedData);
//   console.log(firstRecordCreatedONArray);
//   // firstRecordCreatedONArray.shift()
//   console.log(firstRecordCreatedONArray);

//   return { chartArray, firstRecordCreatedONArray };
// }

export function groupDataByIntervalElectricaal(data, inter, period, startDate) {
  const groupedData = {};
  const firstSelected = data[0];
  const firstRecordCreatedONArray = [];
  const chartArray = [];
  const intervalDates = []; // To store the dates for each interval
  console.log(startDate);
  console.log(data);

  let intervalInMilliseconds;

  // Calculate interval in milliseconds based on period
  switch (period) {
    case "month":
      intervalInMilliseconds = inter * 30.44 * 24 * 60 * 60 * 1000; // Approximate month
      break;
    case "week":
      intervalInMilliseconds = inter * 7 * 24 * 60 * 60 * 1000; // Week
      break;
    case "day":
      intervalInMilliseconds = inter * 24 * 60 * 60 * 1000; // Day
      break;
    case "min":
      intervalInMilliseconds = inter * 60 * 1000; // Minute
      break;
    default:
      throw new Error("Invalid period");
  }

  // Start interval from the specified start date
  let intervalStartTime = new Date(startDate).getTime();

  // Initialize grouped data for each meter
  const meterNames = [...new Set(data.map((item) => item.METERNAME))];
  meterNames.forEach((meterName) => {
    groupedData[meterName] = {};
  });

  // Group data by intervals and meters
  data.forEach((item) => {
    const timestamp = new Date(item.CreatedOn).getTime();
    while (timestamp >= intervalStartTime + intervalInMilliseconds) {
      intervalStartTime += intervalInMilliseconds;
    }
    const intervalKey = new Date(intervalStartTime).toLocaleString();

    if (!groupedData[item.METERNAME][intervalKey]) {
      groupedData[item.METERNAME][intervalKey] = { records: [] };
    }

    groupedData[item.METERNAME][intervalKey].records.push({
      Cumulative: item.KWHTotal,
    });

    if (
      item.MeterId === firstSelected.MeterId &&
      !firstRecordCreatedONArray.includes(intervalKey)
    ) {
      firstRecordCreatedONArray.push(intervalKey);
    }
  });

  // Calculate cumulative values for each interval and fill missing intervals with 0
  for (const meterName in groupedData) {
    const meterValues = [];
    let currentInterval = new Date(startDate).getTime();

    // Iterate over all possible intervals
    while (currentInterval <= new Date().getTime()) {
      const intervalKey = new Date(currentInterval).toLocaleString();
      const intervalDate = new Date(currentInterval).toISOString(); // ISO date format

      if (groupedData[meterName][intervalKey]) {
        const records = groupedData[meterName][intervalKey].records;
        const firstRecord = records[0];
        const lastRecord = records[records.length - 1];

        groupedData[meterName][intervalKey].finalValues = {
          Cumulative: Math.abs(firstRecord?.Cumulative - lastRecord?.Cumulative),
        };
        meterValues.push(groupedData[meterName][intervalKey].finalValues.Cumulative);
      } else {
        groupedData[meterName][intervalKey] = {
          finalValues: { Cumulative: 0 },
        };
        meterValues.push(0);
      }

      intervalDates.push(intervalDate); // Add the interval date to the list
      currentInterval += intervalInMilliseconds;
    }

    // Append data to chartArray for each meter
    chartArray.push({
      name: meterName,
      data: meterValues,
    });
  }

  console.log(chartArray);
  console.log(intervalDates); // Log the interval dates
  console.log(groupedData);
  console.log(firstRecordCreatedONArray);

  return { chartArray, firstRecordCreatedONArray, intervalDates };
}


// export function groupDataByIntervalElectrical(data, inter, period, startDate) {
//   const groupedData = {};
//   const firstSelected = data[0];
//   const firstRecordCreatedONArray = [];
//   const chartArray = [];
//   console.log(startDate);
//   console.log(data);

//   let intervalInMilliseconds;

//   // Calculate interval in milliseconds based on period
//   switch (period) {
//     case "month":
//       intervalInMilliseconds = inter * 30.44 * 24 * 60 * 60 * 1000; // Approximate month
//       break;
//     case "week":
//       intervalInMilliseconds = inter * 7 * 24 * 60 * 60 * 1000; // Week
//       break;
//     case "day":
//       intervalInMilliseconds = inter * 24 * 60 * 60 * 1000; // Day
//       break;
//     case "min":
//       intervalInMilliseconds = inter * 60 * 1000; // Minute
//       break;
//     default:
//       throw new Error("Invalid period");
//   }

//   // Start interval from the specified start date
//   let intervalStartTime = new Date(startDate).getTime();

//   // Initialize grouped data for each meter
//   const meterNames = [...new Set(data.map((item) => item.METERNAME))];
//   meterNames.forEach((meterName) => {
//     groupedData[meterName] = {};
//   });

//   // Group data by intervals and meters
//   data.forEach((item) => {
//     const timestamp = new Date(item.CreatedOn).getTime();
//     while (timestamp >= intervalStartTime + intervalInMilliseconds) {
//       intervalStartTime += intervalInMilliseconds;
//     }
//     const intervalKey = new Date(intervalStartTime).toLocaleString();

//     if (!groupedData[item.METERNAME][intervalKey]) {
//       groupedData[item.METERNAME][intervalKey] = { records: [] };
//     }

//     groupedData[item.METERNAME][intervalKey].records.push({
//       Cumulative: item.KWHTotal,
//     });
//   });

//   // Fill missing intervals and ensure dates are included in `firstRecordCreatedONArray`
//   let currentInterval = new Date(startDate).getTime();
//   while (currentInterval <= new Date().getTime()) {
//     const intervalKey = new Date(currentInterval).toLocaleString();

//     if (!firstRecordCreatedONArray.includes(intervalKey)) {
//       firstRecordCreatedONArray.push(intervalKey);
//     }

//     for (const meterName of meterNames) {
//       if (!groupedData[meterName][intervalKey]) {
//         groupedData[meterName][intervalKey] = {
//           finalValues: { Cumulative: 0 },
//         };
//       }
//     }

//     currentInterval += intervalInMilliseconds;
//   }

//   // Calculate cumulative values and populate `chartArray`
//   for (const meterName in groupedData) {
//     const meterValues = [];
//     const intervals = Object.keys(groupedData[meterName]).sort(
//       (a, b) => new Date(a).getTime() - new Date(b).getTime()
//     );

//     intervals.forEach((intervalKey) => {
//       const records = groupedData[meterName][intervalKey].records || [];
//       const firstRecord = records[0];
//       const lastRecord = records[records.length - 1];

//       if (!groupedData[meterName][intervalKey].finalValues) {
//         groupedData[meterName][intervalKey].finalValues = {};
//       }
//       groupedData[meterName][intervalKey].finalValues.Cumulative =
//         records.length > 0
//           ? Math.abs(firstRecord?.Cumulative - lastRecord?.Cumulative)
//           : 0;

//       meterValues.push(groupedData[meterName][intervalKey].finalValues.Cumulative);
//     });

//     chartArray.push({
//       name: meterName,
//       data: meterValues,
//     });
//   }

//   console.log(chartArray);
//   console.log(groupedData);
//   console.log(firstRecordCreatedONArray);
//   firstRecordCreatedONArray.shift()
//   console.log(firstRecordCreatedONArray);

//   return { chartArray, firstRecordCreatedONArray };
// }


export function groupDataByIntervalElectrical(data, inter, period, startDate, toDate, selectedValue) {
  const groupedData = {};
  const firstRecordCreatedONArray = [];
  const chartArray = [];

  const selectedValues = selectedValue.map((item) => {
    switch (item) {
      case "KWHTOTAL": return "KWHTotal";
      case "KWHIMPORT": return "kWhImport";
      case "KWHEXPORT": return "KWHEXPORT";
      case "KVAH": return "kVAh";
      case "KVARHTOTAL": return "kVArhTotal";
      case "KVARHINDUCTIVE": return "KVARHINDUCTIVE";
      default: return item;
    }
  });

  let intervalInMilliseconds;
  switch (period) {
    case "month":
      intervalInMilliseconds = inter * 30 * 24 * 60 * 60 * 1000;
      break;
    case "week":
      intervalInMilliseconds = inter * 7 * 24 * 60 * 60 * 1000;
      break;
    case "day":
      intervalInMilliseconds = inter * 24 * 60 * 60 * 1000;
      break;
    case "min":
      intervalInMilliseconds = inter * 60 * 1000;
      break;
    default:
      throw new Error("Invalid period");
  }

  const startTimestamp = new Date(startDate).getTime();
  const endTimestamp = new Date(toDate).getTime();

  const meterNames = [...new Set(data.map((item) => item.METERNAME))];
  meterNames.forEach((meterName) => {
    groupedData[meterName] = {};
  });

  // Initialize intervals
  for (let current = startTimestamp; current < endTimestamp; current += intervalInMilliseconds) {
    const intervalKey = new Date(current).toLocaleString();
    firstRecordCreatedONArray.push(intervalKey);
    for (const meterName of meterNames) {
      groupedData[meterName][intervalKey] = {};
      selectedValues.forEach((value) => {
        groupedData[meterName][intervalKey][value] = {
          records: [],
          finalValues: { Cumulative: 0 },
        };
      });
    }
  }

  // Assign each record to its interval
  data.forEach((item) => {
    const timestamp = new Date(item.CreatedOn).getTime();
    if (timestamp < startTimestamp || timestamp > endTimestamp) return;

    const intervalsPassed = Math.floor((timestamp -1 - startTimestamp) / intervalInMilliseconds);
    const intervalStartTime = startTimestamp + intervalsPassed * intervalInMilliseconds;
    const intervalKey = new Date(intervalStartTime).toLocaleString();

    if (groupedData[item.METERNAME] && groupedData[item.METERNAME][intervalKey]) {
      selectedValues.forEach((value) => {
        groupedData[item.METERNAME][intervalKey][value].records.push({
          Cumulative: item[value],
          createdOn: item.CreatedOn,
        });
      });
    }
  });

  // Final calculations
  selectedValues.forEach((val) => {
    for (const meterName in groupedData) {
      const meterValues = [];
      const intervals = Object.keys(groupedData[meterName]).sort(
        (a, b) => new Date(a) - new Date(b)
      ); 

      let previousClosing = null;

      intervals.forEach((intervalKey) => {
        const records = groupedData[meterName][intervalKey][val].records || [];
        records.sort((a, b) => new Date(a.createdOn) - new Date(b.createdOn));

        let openingValue;
        let closingValue;
        console.log(records)

        if (records.length > 0) {
          // Find first non-zero cumulative value
          const firstNonZero = records.find(r => r.Cumulative != null && r.Cumulative !== 0);
          console.log(firstNonZero)
          console.log(previousClosing)

          if (previousClosing == 0 || previousClosing == null) {
            openingValue = firstNonZero?.Cumulative ?? 0; // First interval, get from non-zero
            console.log(openingValue)
          } else {
            openingValue = previousClosing; // Otherwise, carry forward
          }

          closingValue = records[records.length - 1].Cumulative;
        } else {
          // No data: carry forward last known value
          openingValue =  0;
          closingValue = openingValue;
        }

        const cumulative = Math.max(closingValue - openingValue, 0);
        // if (cumulative==0) {
        //   previousClosing=0;
        // }
        console.log(openingValue, closingValue, cumulative);
        groupedData[meterName][intervalKey][val].finalValues.Cumulative = cumulative;

        const intervalStart = new Date(intervalKey).getTime();
        const intervalEnd = intervalStart + intervalInMilliseconds;

        meterValues.push({
          value: cumulative.toFixed(2),
          intervalRange: {
            start: new Date(intervalStart).toLocaleString(),
            end: new Date(intervalEnd).toLocaleString(),
          },
        });

        previousClosing = closingValue;
      });

      chartArray.push({
        name: `${meterName} - ${val}`,
        data: meterValues,
      });
    }
  });
//   selectedValues.forEach((val) => {
//   for (const meterName in groupedData) {
//     const meterValues = [];
//     const intervals = Object.keys(groupedData[meterName]).sort(
//       (a, b) => new Date(a) - new Date(b)
//     );

//     intervals.forEach((intervalKey) => {
//       const records = groupedData[meterName][intervalKey][val].records || [];
//       records.sort((a, b) => new Date(a.createdOn) - new Date(b.createdOn));

//       // Filter non-zero records
//       const nonZeroRecords = records.filter(r => r.Cumulative != null && r.Cumulative !== 0);

//       let openingValue = 0;
//       let closingValue = 0;

//       if (nonZeroRecords.length > 0) {
//         openingValue = nonZeroRecords[0].Cumulative;
//         closingValue = nonZeroRecords[nonZeroRecords.length - 1].Cumulative;
//       }

//       console.log(openingValue,closingValue)
//       const cumulative = Math.max(closingValue - openingValue, 0);
//       console.log(openingValue,closingValue,cumulative)
//       groupedData[meterName][intervalKey][val].finalValues.Cumulative = cumulative;

//       const intervalStart = new Date(intervalKey).getTime();
//       const intervalEnd = intervalStart + intervalInMilliseconds;

//       meterValues.push({
//         value: cumulative.toFixed(2),
//         intervalRange: {
//           start: new Date(intervalStart).toLocaleString(),
//           end: new Date(intervalEnd).toLocaleString(),
//         },
//       });
//     });

//     chartArray.push({
//       name: `${meterName} - ${val}`,
//       data: meterValues,
//     });
//   }
// });


  return { chartArray, firstRecordCreatedONArray };
}

export function groupDataByIntervalElectrical7m11(data, inter, period, startDate, toDate, selectedValue) {
  const groupedData = {};
  const firstRecordCreatedONArray = [];
  const chartArray = [];
  console.log(selectedValue);
  // [
  //   'KWHTOTAL', 'KWHIMPORT', 'KWHEXPORT', 'KVAH', 'KVARHTOTAL', 'KVARHINDUCTIVE'
  // ]
    const selectedValues = selectedValue.map((item) => item==='KWHTOTAL' ? 'KWHTotal' : item==='KWHIMPORT' ? 'kWhImport' : item==='KWHEXPORT' ? 'KWHEXPORT' : item==='KVAH' ? 'kVAh' : item==='KVARHTOTAL' ? 'kVArhTotal' : item==='KVARHINDUCTIVE' ? 'KVARHINDUCTIVE' : item);
  console.log(selectedValues)

  let intervalInMilliseconds;

  // Determine interval duration
  switch (period) {
    case "month":
      intervalInMilliseconds = inter * 30 * 24 * 60 * 60 * 1000;
      break;
    case "week":
      intervalInMilliseconds = inter * 7 * 24 * 60 * 60 * 1000;
      break;
    case "day":
      intervalInMilliseconds = inter * 24 * 60 * 60 * 1000;
      break;
    case "min":
      intervalInMilliseconds = inter * 60 * 1000;
      break;
    default:
      throw new Error("Invalid period");
  }

  const startTimestamp = new Date(startDate).getTime();
  const endTimestamp = new Date(toDate).getTime();
  console.log(new Date(startTimestamp).toLocaleString());
  console.log(new Date(endTimestamp).toLocaleString());

  const meterNames = [...new Set(data.map((item) => item.METERNAME))];
  meterNames.forEach((meterName) => {
    groupedData[meterName] = {};
  });

  console.log(meterNames);

  // Fill intervals for each meter
  for (let current = startTimestamp; current < endTimestamp; current += intervalInMilliseconds) {
    const intervalKey = new Date(current).toLocaleString();
    firstRecordCreatedONArray.push(intervalKey);
    console.log(intervalKey);
    for (const meterName of meterNames) {
      groupedData[meterName][intervalKey] = {};
      selectedValues.forEach((value) => {
        groupedData[meterName][intervalKey][value] = { records: [], finalValues: { Cumulative: 0 } };
      });
    }
  }

  console.log(groupedData);
  console.log(data);

  // Assign records to intervals
  data.forEach((item) => {
    const timestamp = new Date(item.CreatedOn).getTime();
    if (timestamp < startTimestamp || timestamp > endTimestamp) return;

    const intervalsPassed = Math.floor((timestamp - 1 - startTimestamp) / intervalInMilliseconds);
    const intervalStartTime = startTimestamp + intervalsPassed * intervalInMilliseconds;
    const intervalKey = new Date(intervalStartTime).toLocaleString();
    console.log(intervalKey);
    console.log(groupedData[item.METERNAME]);
    console.log(groupedData[item.METERNAME][intervalKey]);

    if (groupedData[item.METERNAME] && groupedData[item.METERNAME][intervalKey]) {
      selectedValues.forEach((value) => {
        groupedData[item.METERNAME][intervalKey][value].records.push({
          Cumulative: item[value],
          createdOn: item.CreatedOn,
        });
      });
    }
  });

  let actualRecordCount = 0;
  Object.values(groupedData).forEach((meter) => {
    Object.values(meter).forEach((interval) => {
      selectedValues.forEach((value) => {
        actualRecordCount += interval[value].records.length;
      });
    });
  });
  console.log("Total records assigned to intervals:", actualRecordCount);

  // Calculate differences and prepare chart data for each selected value
  selectedValues.forEach((selectedValue) => {
    for (const meterName in groupedData) {
      const meterValues = [];
      const intervals = Object.keys(groupedData[meterName]).sort(
        (a, b) => new Date(a).getTime() - new Date(b).getTime()
      );

      let previousClosing = null;
      console.log(intervals);

      intervals.forEach((intervalKey) => {
        const records = groupedData[meterName][intervalKey][selectedValue].records || [];
        records.sort((a, b) => a.timestamp - b.timestamp);
        console.log(records);

        const first = records[0];
        const last = records[records.length - 1];

        // Carry forward last known closing if no new records
        let openingValue = previousClosing ?? (first?.Cumulative ?? 0);
        let closingValue = last?.Cumulative ?? openingValue;

        console.log(first, last);
        console.log(openingValue, closingValue);

        const cumulative = Math.max(closingValue - openingValue, 0);

        groupedData[meterName][intervalKey][selectedValue].finalValues.Cumulative = cumulative;

        const intervalStartTime = new Date(intervalKey).getTime();
        const intervalEndTime = intervalStartTime + intervalInMilliseconds;

        meterValues.push({
          value: cumulative,
          intervalRange: {
            start: new Date(intervalStartTime).toLocaleString(),
            end: new Date(intervalEndTime).toLocaleString(),
          },
        });

        // Update for next interval
        previousClosing = closingValue;
      });

      chartArray.push({
        name: `${meterName} - ${selectedValue}`,
        data: meterValues,
      });
    }
  });

  console.log(chartArray);
  return { chartArray, firstRecordCreatedONArray };
}

export function groupDataByIntervalElectricalas(data, inter, period, startDate, toDate) {
  const groupedData = {};
  const firstRecordCreatedONArray = [];
  const chartArray = [];

  let intervalInMilliseconds;

  // Determine the interval in milliseconds based on the period
  switch (period) {
    case "month":
      intervalInMilliseconds = inter * 30 * 24 * 60 * 60 * 1000; // Approximate month duration
      break;
    case "week":
      intervalInMilliseconds = inter * 7 * 24 * 60 * 60 * 1000; // Weekly duration
      break;
    case "day":
      intervalInMilliseconds = 24 * 60 * 60 * 1000; // 1 Day duration (24 hours)
      break;
    case "min":
      intervalInMilliseconds = inter * 60 * 1000; // Minute duration
      break;
    default:
      throw new Error("Invalid period");
  }

  // Convert start and to dates to timestamps
  const startTimestamp = new Date(startDate).getTime();
  const endTimestamp = new Date(toDate).getTime();

  // Extract unique meter names
  const meterNames = [...new Set(data.map((item) => item.METERNAME))];
  meterNames.forEach((meterName) => {
    groupedData[meterName] = {};
  });

  // Group data by intervals for each meter
  data.forEach((item) => {
    const timestamp = new Date(item.CreatedOn).getTime();
    const intervalStartTime =
      startTimestamp +
      Math.floor((timestamp - startTimestamp) / intervalInMilliseconds) *
        intervalInMilliseconds;
    const intervalKey = new Date(intervalStartTime).toLocaleString();

    if (!groupedData[item.METERNAME][intervalKey]) {
      groupedData[item.METERNAME][intervalKey] = { records: [] };
    }

    groupedData[item.METERNAME][intervalKey].records.push({
      Cumulative: item.KWHTotal,
    });
  });

  // Fill missing intervals and prepare the date array
  let currentInterval = startTimestamp;
  const maxIntervals = Math.floor((endTimestamp - startTimestamp) / intervalInMilliseconds);

  let intervalsAdded = 0;
  while (currentInterval <= endTimestamp && intervalsAdded < maxIntervals) {
    const intervalKey = new Date(currentInterval).toLocaleString();

    if (!firstRecordCreatedONArray.includes(intervalKey)) {
      firstRecordCreatedONArray.push(intervalKey);
    }

    for (const meterName of meterNames) {
      if (!groupedData[meterName][intervalKey]) {
        groupedData[meterName][intervalKey] = {
          finalValues: { Cumulative: 0 },
        };
      }
    }

    currentInterval += intervalInMilliseconds;
    intervalsAdded++;
  }

  // Calculate cumulative values and prepare chart data
  for (const meterName in groupedData) {
    const meterValues = [];
    const intervals = Object.keys(groupedData[meterName]).sort(
      (a, b) => new Date(a).getTime() - new Date(b).getTime()
    );

    intervals.forEach((intervalKey) => {
      const records = groupedData[meterName][intervalKey].records || [];
      const firstRecord = records[0];
      const lastRecord = records[records.length - 1];

      if (!groupedData[meterName][intervalKey].finalValues) {
        groupedData[meterName][intervalKey].finalValues = {};
      }
      groupedData[meterName][intervalKey].finalValues.Cumulative =
        records.length > 0
          ? Math.abs(firstRecord?.Cumulative - lastRecord?.Cumulative)
          : 0;

      meterValues.push(
        groupedData[meterName][intervalKey].finalValues.Cumulative
      );
    });

    chartArray.push({
      name: meterName,
      data: meterValues,
    });
  }

  // Ensure the first record array matches the data points length
  // firstRecordCreatedONArray.shift();
  console.log(firstRecordCreatedONArray);

  return { chartArray, firstRecordCreatedONArray };
}


export function groupDataByIntervalElecatrical(data, inter, period, startDate, toDate) {
  const groupedData = {};
  const firstRecordCreatedONArray = [];
  const chartArray = [];

  console.log(startDate, toDate);
  console.log(data);
  console.log(inter, period);

  let intervalInMilliseconds;

  // Determine the interval in milliseconds based on the period
  switch (period) {
    case "month":
      intervalInMilliseconds = inter * 30.44 * 24 * 60 * 60 * 1000; // Approximate month duration
      break;
    case "week":
      intervalInMilliseconds = inter * 7 * 24 * 60 * 60 * 1000; // Weekly duration
      break;
    case "day":
      intervalInMilliseconds = inter * 24 * 60 * 60 * 1000; // Daily duration
      break;
    case "min":
      intervalInMilliseconds = inter * 60 * 1000; // Minute duration
      break;
    default:
      throw new Error("Invalid period");
  }

  // Convert start and to dates to timestamps
  const startTimestamp = new Date(startDate).getTime();
  const endTimestamp = new Date(toDate).getTime();

  // Extract unique meter names
  const meterNames = [...new Set(data.map((item) => item.METERNAME))];
  meterNames.forEach((meterName) => {
    groupedData[meterName] = {};
  });

  // Group data by intervals for each meter
  data.forEach((item) => {
    const timestamp = new Date(item.CreatedOn).getTime();
    const intervalStartTime =
      startTimestamp +
      Math.floor((timestamp - startTimestamp) / intervalInMilliseconds) *
        intervalInMilliseconds;
    const intervalKey = new Date(intervalStartTime).toLocaleString();

    if (!groupedData[item.METERNAME][intervalKey]) {
      groupedData[item.METERNAME][intervalKey] = { records: [] };
    }

    groupedData[item.METERNAME][intervalKey].records.push({
      Cumulative: item.KWHTotal,
    });
  });

  // Fill missing intervals and prepare the date array
  let currentInterval = startTimestamp;
  const maxIntervals = Math.floor((endTimestamp - startTimestamp) / intervalInMilliseconds);

  let intervalsAdded = 0;
  while (currentInterval <= endTimestamp && intervalsAdded < inter) {
    const intervalKey = new Date(currentInterval).toLocaleString();

    if (!firstRecordCreatedONArray.includes(intervalKey)) {
      firstRecordCreatedONArray.push(intervalKey);
    }

    for (const meterName of meterNames) {
      if (!groupedData[meterName][intervalKey]) {
        groupedData[meterName][intervalKey] = {
          finalValues: { Cumulative: 0 },
        };
      }
    }

    currentInterval += intervalInMilliseconds;
    intervalsAdded++;
  }

  // Calculate cumulative values and prepare chart data
  for (const meterName in groupedData) {
    const meterValues = [];
    const intervals = Object.keys(groupedData[meterName]).sort(
      (a, b) => new Date(a).getTime() - new Date(b).getTime()
    );

    intervals.forEach((intervalKey) => {
      const records = groupedData[meterName][intervalKey].records || [];
      const firstRecord = records[0];
      const lastRecord = records[records.length - 1];

      if (!groupedData[meterName][intervalKey].finalValues) {
        groupedData[meterName][intervalKey].finalValues = {};
      }
      groupedData[meterName][intervalKey].finalValues.Cumulative =
        records.length > 0
          ? Math.abs(firstRecord?.Cumulative - lastRecord?.Cumulative)
          : 0;

      meterValues.push(
        groupedData[meterName][intervalKey].finalValues.Cumulative
      );
    });

    chartArray.push({
      name: meterName,
      data: meterValues,
    });
  }

  console.log(chartArray);
  console.log(groupedData);
  console.log(firstRecordCreatedONArray);
  firstRecordCreatedONArray.shift()
  console.log(firstRecordCreatedONArray);

  return { chartArray, firstRecordCreatedONArray };
}



export function groupDataByIntervalAir1(data, inter, period, startDate, toDate, selectedValues) {
  const groupedData = {};
  const firstRecordCreatedONArray = [];
  const chartArray = [];

  let intervalInMilliseconds;

  // Determine the interval in milliseconds based on the period
  switch (period) {
    case "month":
      intervalInMilliseconds = inter * 30 * 24 * 60 * 60 * 1000; // Approximate month duration
      break;
    case "week":
      intervalInMilliseconds = inter * 7 * 24 * 60 * 60 * 1000; // Weekly duration
      break;
    case "day":
      intervalInMilliseconds = 24 * 60 * 60 * 1000; // 1 Day duration (24 hours)
      break;
    case "min":
      intervalInMilliseconds = inter * 60 * 1000; // Minute duration
      break;
    default:
      throw new Error("Invalid period");
  }

  // Convert start and to dates to timestamps
  const startTimestamp = new Date(startDate).getTime();
  const endTimestamp = new Date(toDate).getTime();

  // Extract unique meter names
  const meterNames = [...new Set(data.map((item) => item.metername))];
  meterNames.forEach((meterName) => {
    groupedData[meterName] = {};
  });

  // Group data by intervals for each meter
  data.forEach((item) => {
    const timestamp = new Date(item.createdON).getTime();
    const intervalStartTime =
      startTimestamp +
      Math.floor((timestamp - startTimestamp) / intervalInMilliseconds) *
        intervalInMilliseconds;
    const intervalEndTime = intervalStartTime + intervalInMilliseconds;
    const intervalKey = new Date(intervalEndTime).toLocaleString();

    if (!groupedData[item.metername][intervalKey]) {
      groupedData[item.metername][intervalKey] = { records: [] };
    }

    groupedData[item.metername][intervalKey].records.push({
      flowRate: item.flowRate,
      cumulative: item.cumulative,
    });
  });

  // Fill missing intervals and prepare the date array
  let currentInterval = startTimestamp;
  const maxIntervals = Math.floor((endTimestamp - startTimestamp) / intervalInMilliseconds);

  let intervalsAdded = 0;
  while (currentInterval <= endTimestamp && intervalsAdded < maxIntervals) {
    const intervalEndTime = currentInterval + intervalInMilliseconds;
    const intervalKey = new Date(intervalEndTime).toLocaleString();

    if (!firstRecordCreatedONArray.includes(intervalKey)) {
      firstRecordCreatedONArray.push(intervalKey);
    }

    for (const meterName of meterNames) {
      if (!groupedData[meterName][intervalKey]) {
        groupedData[meterName][intervalKey] = {
          finalValues: { flowRate: 0, cumulative: 0 },
        };
      }
    }

    currentInterval += intervalInMilliseconds;
    intervalsAdded++;
  }

  // Calculate cumulative values and prepare chart data
  for (const meterName in groupedData) {
    const metricData = {};

    // Initialize arrays for selected values
    selectedValues.forEach((metric) => {
      metricData[metric] = [];
    });

    const intervals = Object.keys(groupedData[meterName]).sort(
      (a, b) => new Date(a).getTime() - new Date(b).getTime()
    );

    intervals.forEach((intervalKey) => {
      const records = groupedData[meterName][intervalKey].records || [];
      const firstRecord = records[0];
      const lastRecord = records[records.length - 1];

      if (!groupedData[meterName][intervalKey].finalValues) {
        groupedData[meterName][intervalKey].finalValues = {};
      }

      groupedData[meterName][intervalKey].finalValues.flowRate =
        records.reduce((sum, record) => sum + record.flowRate, 0) / records.length || 0;

      groupedData[meterName][intervalKey].finalValues.cumulative =
        records.length > 0
          ? Math.abs(firstRecord?.cumulative - lastRecord?.cumulative)
          : 0;

      // Add data to the respective arrays based on selected values
      selectedValues.forEach((metric) => {
        metricData[metric].push({
          interval: intervalKey,
          value: groupedData[meterName][intervalKey].finalValues[metric],
        });
      });
    });

    // Push data to chartArray for selected values
    selectedValues.forEach((metric) => {
      chartArray.push({
        name: `${meterName}-${metric}`,
        data: metricData[metric],
      });
    });
  }

  // Ensure the first record array matches the data points length
  console.log(firstRecordCreatedONArray);

  return { chartArray, firstRecordCreatedONArray };
}



export function groupDataByIntervalAir(data, inter, period, startDate, toDate, selectedValues) {
  const groupedData = {};
  const firstRecordCreatedONArray = [];
  const chartArray = [];

  let intervalInMilliseconds;

  // Determine the interval in milliseconds based on the period
  switch (period) {
    case "month":
      intervalInMilliseconds = inter * 30 * 24 * 60 * 60 * 1000; // Approximate month duration
      break;
    case "week":
      intervalInMilliseconds = inter * 7 * 24 * 60 * 60 * 1000; // Weekly duration
      break;
    case "day":
      intervalInMilliseconds = 24 * 60 * 60 * 1000; // 1 Day duration (24 hours)
      break;
    case "min":
      intervalInMilliseconds = inter * 60 * 1000; // Minute duration
      break;
    default:
      throw new Error("Invalid period");
  }

  // Convert start and to dates to timestamps
  const startTimestamp = new Date(startDate).getTime();
  const endTimestamp = new Date(toDate).getTime();

  // Extract unique meter names
  const meterNames = [...new Set(data.map((item) => item.metername))];
  meterNames.forEach((meterName) => {
    groupedData[meterName] = {};
  });

  // Group data by intervals for each meter
  data.forEach((item) => {
    const timestamp = new Date(item.createdON).getTime();
    const intervalStartTime =
      startTimestamp +
      Math.floor((timestamp - startTimestamp) / intervalInMilliseconds) *
        intervalInMilliseconds;
    const intervalEndTime = intervalStartTime + intervalInMilliseconds;
    const intervalKey = new Date(intervalEndTime).toLocaleString();

    if (!groupedData[item.metername][intervalKey]) {
      groupedData[item.metername][intervalKey] = { records: [] };
    }

    groupedData[item.metername][intervalKey].records.push({
      flowRate: item.flowRate,
      cumulative: item.cumulative,
    });
  });

  // Fill missing intervals and prepare the date array
  let currentInterval = startTimestamp;
  const maxIntervals = Math.floor((endTimestamp - startTimestamp) / intervalInMilliseconds);

  let intervalsAdded = 0;
  while (currentInterval <= endTimestamp && intervalsAdded < maxIntervals) {
    const intervalEndTime = currentInterval + intervalInMilliseconds;
    const intervalKey = new Date(intervalEndTime).toLocaleString();

    if (!firstRecordCreatedONArray.includes(intervalKey)) {
      firstRecordCreatedONArray.push(intervalKey);
    }

    for (const meterName of meterNames) {
      if (!groupedData[meterName][intervalKey]) {
        groupedData[meterName][intervalKey] = {
          finalValues: { flowRate: 0, cumulative: 0 },
        };
      }
    }

    currentInterval += intervalInMilliseconds;
    intervalsAdded++;
  }

  // Calculate cumulative values and prepare chart data
  for (const meterName in groupedData) {
    const metricData = {};

    // Initialize arrays for selected values
    selectedValues.forEach((metric) => {
      metricData[metric] = [];
    });

    const intervals = Object.keys(groupedData[meterName]).sort(
      (a, b) => new Date(a).getTime() - new Date(b).getTime()
    );

    intervals.forEach((intervalKey) => {
      const records = groupedData[meterName][intervalKey].records || [];
      const firstRecord = records[0];
      const lastRecord = records[records.length - 1];

      if (!groupedData[meterName][intervalKey].finalValues) {
        groupedData[meterName][intervalKey].finalValues = {};
      }

      // Calculate flowRate
      groupedData[meterName][intervalKey].finalValues.flowRate =
        records.reduce((sum, record) => sum + record.flowRate, 0) / records.length || 0;

      // Calculate cumulative
      if (records.length > 0 && firstRecord && lastRecord) {
        groupedData[meterName][intervalKey].finalValues.cumulative = Math.abs(
          lastRecord.cumulative - firstRecord.cumulative
        );
        groupedData[meterName][intervalKey].finalValues.flowRate = Math.abs(
          lastRecord.flowRate - firstRecord.flowRate
        );
      } else {
        groupedData[meterName][intervalKey].finalValues.cumulative = 0;
        groupedData[meterName][intervalKey].finalValues.flowRate = 0;
      }

      // Add data to the respective arrays based on selected values
      selectedValues.forEach((metric) => {
        metricData[metric].push({
          interval: intervalKey,
          value: groupedData[meterName][intervalKey].finalValues[metric],
        });
      });
    });
    console.log(chartArray)

    // Push data to chartArray for selected values
    selectedValues.forEach((metric) => {
      chartArray.push({
        name: `${meterName}-${metric}`,
        data: metricData[metric],
      });
    });
  }

  // Ensure the first record array matches the data points length
  console.log(firstRecordCreatedONArray);

  return { chartArray, firstRecordCreatedONArray };
}


export function generateISOFormatDateString(date) {
  // console.log(date);
  const padZero = (num) => (num < 10 ? `0${num}` : num);

  const year = date.getFullYear();
  const month = padZero(date.getMonth() + 1);
  const day = padZero(date.getDate());
  const hour = padZero(date.getHours());
  const minute = padZero(date.getMinutes());
  const second = padZero(date.getSeconds());

  const formattedDate = `${year}-${month}-${day}T${hour}:${minute}:${second}.000Z`;

  return formattedDate;
}


// export function calculateDateRangeFromDate(date, minutesBefore, minutesAfter) {
//   // console.log(date,minutesAfter,minutesBefore)
//   const fromDate = new Date(date);
//   const toDate = new Date(date);
//   // console.log("fromdate"+fromDate)

//   const fromMin = fromDate.getMinutes() - minutesBefore;
//   const toMin = toDate.getMinutes() + minutesAfter;

//   fromDate.setMinutes(fromMin);
//   toDate.setMinutes(toMin);
//   // console.log('helo'+fromDate)

//   // Set current hours
//   // const currentHours = date.getHours();
//   // fromDate.setUTCHours(currentHours);
//   // toDate.setUTCHours(currentHours);

//   const formattedFromDate = generateISOFormatDateString(fromDate)
//   // console.log(formattedFromDate) 
//   const formattedToDate = generateISOFormatDateString(toDate)

//   return {
//     from: formattedFromDate,
//     to: formattedToDate,
//   };
// }

export function adjustTimeByFiveHoursThirtyMinutes(date) {
  // Create a new Date object to avoid mutating the original
  const adjustedDate = new Date(date);

  // Adjust the time by 5 hours and 30 minutes
  adjustedDate.setHours(adjustedDate.getHours() + 5);
  adjustedDate.setMinutes(adjustedDate.getMinutes() + 30);

  // Return the adjusted date in ISO 8601 format
  return adjustedDate.toISOString();
}




function adjustDateAfter6() {
  // var currentDate = new Date('2024-04-09T01:45:00.000Z');
  var currentDate = new Date();
  
  var thresholdTime = new Date();
  thresholdTime.setHours(6, 0, 0, 0);

  if (currentDate < thresholdTime) {
      currentDate.setDate(currentDate.getDate() - 1);
      return currentDate; 
  } else {
      currentDate.setDate(currentDate.getDate());
      return currentDate; 
  }
}



export const calculateOneDayDateRangeFrom6AM = () => {
  // const dayStartTime = config.dayStartTime;
  const todayIST = adjustDateAfter6();
  // const todayIST = new Date();
  todayIST.setHours(6,0,0,0);
  // console.log(todayIST)
  // console.log(todayIST.toLocaleString())

  const lastDate = new Date(todayIST.getTime() -  24* 60 * 60 * 1000);
  // console.log(lastDate.toLocaleString())

  console.log() 
      // Format the dates to ISO format
  const formattedFromDate = generateISOFormatDateString(lastDate);
  const formattedToDate = generateISOFormatDateString(todayIST);
  console.log(formattedFromDate)
  console.log(formattedToDate) 

  return {
    from: formattedFromDate,
    to: formattedToDate,
  };
  // return {
  //     fromDate: getFormattedDate(lastDate), 
  //     toDate: getFormattedDate(todayIST)
  // }
}





